import * as firebase from 'firebase'

const config = {
	apiKey: 'AIzaSyDLr80baGCc9yi-LqPOB95arzlrtSv6_yw',
	authDomain: 'atc-bi.firebaseapp.com',
	databaseURL: 'https://atc-bi.firebaseio.com',
	projectId: 'atc-bi',
	storageBucket: 'atc-bi.appspot.com',
	messagingSenderId: '1062412169696'
};
firebase.initializeApp(config);

const db = firebase.database();
const auth = firebase.auth();
const messaging = firebase.messaging();

export {
	db,
	auth,
	messaging
}



// WEBPACK FOOTER //
// ./src/firebase.config.js